import fieldBaseTpl from '../base';

const fieldTextTpl = (initData = {}) => {
    return fieldBaseTpl(initData);
}

export { fieldTextTpl }